import { useState, useRef, useEffect } from "react";
import { submitFeedback } from "../../services/feedback";
import styles from "./CopyBtn.module.css";
import { commonIcon } from "../../asset";

const FeedbackBtn = ({ messageId, chatHistoryId, question, aiResponse }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [state, setState] = useState("idle");
  const popupRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  useEffect(() => {
    if (open && textareaRef.current) {
      setTimeout(() => textareaRef.current?.focus(), 50);
    }
  }, [open]);

  const handleOpen = () => {
    setOpen(true);
    setState("idle");
    setText("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setState("loading");
    try {
      await submitFeedback({ messageId, chatHistoryId, question, aiResponse, feedbackText: text.trim() });
      setState("success");
      setTimeout(() => { setOpen(false); setState("idle"); setText(""); }, 1800);
    } catch {
      setState("error");
    }
  };

  return (
    <div className="relative">
      <div
        onClick={handleOpen}
        className={`${styles["copy-icon"]} ${styles["feedback-icon-one"]}`}
        role="button"
        aria-label="Give feedback on this response"
      >
        <img src={commonIcon.feedbackIcon} alt="feedback" />
      </div>

      {open && (
        <div
          ref={popupRef}
          style={{
            position: "absolute",
            bottom: "calc(100% + 8px)",
            left: "0",
            zIndex: 50,
            width: "300px",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "12px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #f3f4f6" }}>
            <span style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937" }}>Feedback on this response</span>
            <button
              onClick={() => setOpen(false)}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: "18px", lineHeight: 1, padding: "0 2px" }}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          {state === "success" ? (
            <div style={{ padding: "24px 16px", display: "flex", flexDirection: "column", alignItems: "center", gap: "8px", textAlign: "center" }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <p style={{ fontSize: "13px", fontWeight: 500, color: "#374151", margin: 0 }}>Thank you for your feedback!</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ padding: "14px 16px", display: "flex", flexDirection: "column", gap: "10px" }}>
              <p style={{ fontSize: "12px", color: "#6b7280", margin: 0 }}>
                Your feedback helps us improve Gospel Truth AI responses.
              </p>
              <textarea
                ref={textareaRef}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="What was helpful or could be improved?"
                rows={4}
                maxLength={1000}
                disabled={state === "loading"}
                style={{ width: "100%", borderRadius: "8px", border: "1px solid #d1d5db", padding: "8px 12px", fontSize: "13px", color: "#374151", resize: "none", outline: "none", boxSizing: "border-box" }}
              />
              {state === "error" && (
                <p style={{ fontSize: "12px", color: "#ef4444", margin: 0 }}>Something went wrong. Please try again.</p>
              )}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: "11px", color: "#9ca3af" }}>{text.length}/1000</span>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    disabled={state === "loading"}
                    style={{ padding: "5px 12px", borderRadius: "6px", border: "none", background: "none", cursor: "pointer", fontSize: "12px", color: "#6b7280" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={!text.trim() || state === "loading"}
                    style={{ padding: "5px 14px", borderRadius: "6px", border: "none", cursor: "pointer", fontSize: "12px", fontWeight: 600, color: "#fff", background: !text.trim() || state === "loading" ? "#9ca3af" : "#1f2937" }}
                  >
                    {state === "loading" ? "Sending…" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default FeedbackBtn;
